import { render } from "./ServicesPages.vue?vue&type=template&id=53a93388"
import script from "./ServicesPages.vue?vue&type=script&lang=js"
export * from "./ServicesPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__